import * as React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { Card } from '@workday/canvas-kit-react/card';
import { usePopupModel } from './hooks';
export const PopupBody = createSubcomponent('div')({
    displayName: 'Popup.Body',
    modelHook: usePopupModel,
})(elemProps => {
    return React.createElement(Card.Body, Object.assign({ overflowY: "auto", padding: "xxs" }, elemProps));
});
